/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-newline */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import GalleryContentCard from '@components/MediaGallery/MediaGalleryItem/GalleryContentCard';
import GalleryImage from '@components/MediaGallery/MediaGalleryItem/GalleryImage';
import './index.scss';

/**
 * Takes card data and renders it
 * as a GalleryImage or GalleryContentCard,
 * depending on the if the card has a title field.
 */
const MediaGalleryItem = ({ card }) => (
  <div style={{ padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    { !card.title
      ? <GalleryImage card={card} />
      : <GalleryContentCard card={card} />}
  </div>
);

MediaGalleryItem.defaultProps = {
  card: null,
};

MediaGalleryItem.propTypes = {
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  card: PropTypes.objectOf(PropTypes.any),
};

export default MediaGalleryItem;
